export default function FloorHeader({

    floorName,
    observationHour,
    onPreviousHour,
    onNextHour,

    showUnprocessed,
    setShowUnprocessed,

    processedPercent,
    processedCount,
    total,

    showSubmitButton,
    showSubmittedLabel,
    handleSubmit,

    floorCount
}) {

    /**************************************************************************
     * Format Hour
     *************************************************************************/
    function formatHour(hour) {

        const start =
            hour.toString().padStart(2, "0") + ":00";

        const endHour =
            (hour + 1) % 24;

        const end =
            endHour.toString().padStart(2, "0") + ":00";

        return start + " - " + end;
    }

    return (

        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 18px",
                background:
                    "linear-gradient(180deg,#1e293b 0%, #0f172a 100%)",
                borderBottom:
                    "1px solid rgba(255,255,255,0.06)",
                boxShadow:
                    "0 4px 18px rgba(0,0,0,0.35)",
                position: "relative",
                zIndex: 10
            }}
        >

            {/* LEFT SIDE */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    width: "100%"
                }}
            >

                {/* FLOOR NAME */}
                <div
                    style={{
                        fontWeight: "700",
                        fontSize: "15px",
                        color: "#ffffff",
                        paddingLeft: "6px",
                        whiteSpace: "nowrap"
                    }}
                >
                    {floorName}
                </div>

                {/* SURVEY HOUR CONTROL */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 10px",
                        borderRadius: "16px",
                        background:
                            "linear-gradient(180deg,#334155 0%, #1e293b 100%)",
                        border:
                            "1px solid rgba(255,255,255,0.06)",
                        boxShadow:
                            "0 0 18px rgba(90,155,214,0.20)",
                        whiteSpace: "nowrap",
                        gap: "10px"
                    }}
                >

                    {/* LABEL */}
                    <div
                        style={{
                            fontSize: "10px",
                            fontWeight: "700",
                            letterSpacing: "1px",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            paddingLeft: "4px"
                        }}
                    >
                        Survey
                    </div>

                  

                    {/* HOUR */}
                    <div
                        style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            color: "#ffffff",
                            minWidth: "112px",
                            textAlign: "center"
                        }}
                    >
                        {formatHour(observationHour)}
                    </div>

                </div>

                {/* SHOW UNPROCESSED */}
                <button
                    onClick={() => setShowUnprocessed(!showUnprocessed)}
                    style={{
                        padding: "10px 18px",
                        background:
                            "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "12px",
                        cursor: "pointer",
                        fontWeight: "700",
                        fontSize: "13px",
                        minWidth: "190px",
                        boxShadow:
                            "0 8px 20px rgba(90,155,214,0.35)",
                        transition: "all 0.2s ease",
                        whiteSpace: "nowrap"
                    }}
                >
                    {
                        showUnprocessed
                            ? "Hide Unprocessed"
                            : "Show Unprocessed"
                    }
                </button>

                {/* STATUS */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        whiteSpace: "nowrap"
                    }}
                >

                    <div
                        style={{
                            fontSize: "14px",
                            fontWeight: "700",
                            color: "#ffffff",
                            whiteSpace: "nowrap"
                        }}
                    >
                        Floor {processedPercent}% processed ({processedCount}/{total})
                    </div>

                </div>

                {/* SUBMIT BUTTON */}
                {
                    showSubmitButton &&
                    (
                        <button
                            onClick={() => handleSubmit(floorCount)}
                            style={{
                                marginLeft: "6px",
                                padding: "10px 22px",
                                background:
                                    "linear-gradient(180deg,#ff5f5f 0%, #ef4444 100%)",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "12px",
                                cursor: "pointer",
                                fontWeight: "700",
                                fontSize: "13px",
                                boxShadow:
                                    "0 8px 20px rgba(239,68,68,0.35)",
                                transition: "all 0.2s ease",
                                whiteSpace: "nowrap"
                            }}
                        >
                            Submit Hour
                        </button>
                    )
                }

                {/* SUBMITTED */}
                {
                    showSubmittedLabel &&
                    (
                        <div
                            style={{
                                marginLeft: "6px",
                                padding: "10px 18px",
                                background:
                                    "linear-gradient(180deg,#22c55e 0%, #16a34a 100%)",
                                color: "#ffffff",
                                borderRadius: "12px",
                                fontWeight: "700",
                                fontSize: "13px",
                                boxShadow:
                                    "0 8px 20px rgba(34,197,94,0.30)",
                                whiteSpace: "nowrap"
                            }}
                        >
                            Submitted
                        </div>
                    )
                }

            </div>

            {/* BOTTOM ACCENT */}
            <div
                style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    height: "2px",
                    background:
                        "linear-gradient(90deg,#5a9bd6,#22d3ee,#5a9bd6)"
                }}
            />

        </div>
    );
}